// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"205":"db006a16","435":"9e965e80","518":"48f30a54","669":"9aea885f","670":"61e09b82","816":"e30bc76d"}[chunkId] + ".chunk.css";
};